import { render, staticRenderFns } from "./SimplifiedOrderTable.vue?vue&type=template&id=5ec8b50b&scoped=true&"
import script from "./SimplifiedOrderTable.vue?vue&type=script&lang=js&"
export * from "./SimplifiedOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./SimplifiedOrderTable.vue?vue&type=style&index=0&id=5ec8b50b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8b50b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec8b50b')) {
      api.createRecord('5ec8b50b', component.options)
    } else {
      api.reload('5ec8b50b', component.options)
    }
    module.hot.accept("./SimplifiedOrderTable.vue?vue&type=template&id=5ec8b50b&scoped=true&", function () {
      api.rerender('5ec8b50b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/SimplifiedOrderTable.vue"
export default component.exports